import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiTokenService } from "@sharedV11/services/api/token/api-token.service";
import { GlobalService } from "@sharedV11/services/global/global.service";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({
  providedIn: "root",
})
export class ComplementosV11Service {
  constructor(
    private http: HttpClient,
    private tokenService: ApiTokenService,
    private global: GlobalService
  ) {}

  /**
   * Lista complementos com paginação e filtros.
   * clienteAPI e ConexionIacpos são injetados pelo RequestInterceptor.
   */
  getComplementos(paginator: any, filters: any[]): Observable<any> {
    const basePaginator = paginator || {
      page: 1,
      pagelements: 10,
      orderby: "pkId",
      ordertype: "ASC",
    };

    // A API de Complementos só aceita alguns campos de ordenação:
    // pkId, chNombre, chDescripción. Mapeamos os campos de UI para estes.
    let orderby = basePaginator.orderby || "pkId";
    if (orderby === "Nombre") {
      orderby = "chNombre";
    } else if (orderby === "Descripcion" || orderby === "Descripción") {
      orderby = "chDescripcion";
    }

    const mappedPaginator = {
      ...basePaginator,
      orderby,
    };

    const apiFilters = Array.isArray(filters) ? [...filters] : [];
    // Se nenhum filtro veio do front, enviamos a lista \"vazia\" esperada pela API.
    if (apiFilters.length === 0) {
      apiFilters.push(
        { name: "pkId", value: "" },
        { name: "Nombre", value: "" },
        { name: "Descripcion", value: "" },
        { name: "CentrosIds", value: "" },
        { name: "CentrosNombres", value: "" }
      );
    }

    const peticion: any = {
      paginator: mappedPaginator,
      filters: apiFilters,
    };
    return this.http
      .post<any>(
        this.tokenService.getConfig("API_URL") + "Customan/GetComplemento",
        JSON.stringify(peticion),
        httpOptions
      )
      .pipe(
        map((data) => data),
        catchError((error: HttpErrorResponse) => throwError(error))
      );
  }

  /**
   * Obtém um único complemento por pkId (para editar/duplicar).
   */
  getComplementoById(pkId: string): Observable<any> {
    const peticion = {
      paginator: { page: 1, pagelements: 1, orderby: "pkId", ordertype: "ASC" },
      filters: [{ name: "pkId", value: pkId }],
    };
    return this.http
      .post<any>(
        this.tokenService.getConfig("API_URL") + "Customan/GetComplemento",
        JSON.stringify(peticion),
        httpOptions
      )
      .pipe(
        map((data) => data),
        catchError((error: HttpErrorResponse) => throwError(error))
      );
  }

  /**
   * Insere ou atualiza complemento.
   * pkId: "0" para inserção; id do registro para atualização.
   * CentrosIds: string com ids separados por vírgula (opcional).
   */
  insUpdComplemento(payload: {
    pkId: string;
    Nombre: string;
    Descripcion?: string;
    CentrosIds?: string;
  }): Observable<any> {
    const body = {
      ...payload,
      clienteAPI: this.global.clienteapi,
      ConexionIacpos: localStorage.getItem("conexionIACPOS"),
    };
    return this.http
      .post<any>(
        this.tokenService.getConfig("API_URL") + "Customan/InsUpdComplemento",
        JSON.stringify(body),
        httpOptions
      )
      .pipe(
        map((data) => data),
        catchError((error: HttpErrorResponse) => throwError(error))
      );
  }

  /**
   * Elimina um complemento por pkId.
   */
  delComplemento(pkId: string): Observable<any> {
    const peticion = {
      pkId,
      clienteAPI: this.global.clienteapi,
      ConexionIacpos: localStorage.getItem("conexionIACPOS"),
    };
    return this.http
      .post<any>(
        this.tokenService.getConfig("API_URL") + "Customan/DelComplemento",
        JSON.stringify(peticion),
        httpOptions
      )
      .pipe(
        map((data) => data),
        catchError((error: HttpErrorResponse) => throwError(error))
      );
  }
}
